function createSerialExecutor() {
  const queues = new Map(); // key -> Promise

  return function enqueue(key, taskFn) {
    const prev = queues.get(key) || Promise.resolve();

    const next = prev
      .catch(() => { })
      .then(() => taskFn());

    const wrapped = next.finally(() => {
      if (queues.get(key) === wrapped) {
        queues.delete(key);
      }
    });

    queues.set(key, wrapped);
    return wrapped;
  };
}

export {
  createSerialExecutor
}